import * as FlatModels from '@medsurf/flat-models';

// <editor-fold desc="Action Types">

/**
 * Action Types
 */
export enum ActionTypes {
  /**
   * Store
   */
  GetSlideEntitySuccess = '[STORE | CONTROL | SLIDE] Get Slide Entity Success',
  GetSlideEntitiesSuccess = '[STORE | CONTROL | SLIDE] Get Slide Entities Success',
  GetSlideDataByPageId = '[STORE | CONTROL | SLIDE] Get Slide Data By Page Id',
  GetSlideDataBySlideId = '[STORE | CONTROL | SLIDE] Get Slide Data By Slide Id',
  AddAvailableSlide = '[STORE | CONTROL | SLIDE] Add Available Slide',
  RemoveAvailableSlide = '[STORE | CONTROL | SLIDE] Remove Available Slide',
  /**
   * Request
   */
  GetSlideDataByPageIdRequest = '[REQUEST | CONTROL | SLIDE] Get Slide Data By Page Id Request',
  GetSlideDataBySlideIdRequest = '[REQUEST | CONTROL | SLIDE] Get Slide Data By Slide Id Request',
}

// </editor-fold>

// <editor-fold desc="Models">

// </editor-fold>

// <editor-fold desc="Store">

/**
 * Get Slide Entity Success
 */
export class GetSlideEntitySuccess {
  public static readonly type = ActionTypes.GetSlideEntitySuccess;

  public constructor(public entityQueryResult: FlatModels.SlideViewerModels.SlideViewerPageQueryResult) {
  }
}

/**
 * Get Slide Entities Success
 */
export class GetSlideEntitiesSuccess {
  public static readonly type = ActionTypes.GetSlideEntitiesSuccess;

  public constructor(public entityQueryResults: FlatModels.SlideViewerModels.SlideViewerPageQueryResult[]) {
  }
}

/**
 * Get Slide Data By Page Id
 */
export class GetSlideDataByPageId {
  public static readonly type = ActionTypes.GetSlideDataByPageId;

  public constructor(public pageId: string) {
  }
}

/**
 * Get Slide Data By Slide Id
 */
export class GetSlideDataBySlideId {
  public static readonly type = ActionTypes.GetSlideDataBySlideId;

  public constructor(public slideId: number) {
  }
}

/**
 * Add Available Slide
 */
export class AddAvailableSlide {
  public static readonly type = ActionTypes.AddAvailableSlide;

  public constructor(public slideId: string) {
  }
}

/**
 * Remove Available Slide
 */
export class RemoveAvailableSlide {
  public static readonly type = ActionTypes.RemoveAvailableSlide;

  public constructor(public slideId: string) {
  }
}

// </editor-fold>

// <editor-fold desc="Request">

/**
 * Get Slide Data By Page Id Request
 */
export class GetSlideDataByPageIdRequest {
  public static readonly type = ActionTypes.GetSlideDataByPageIdRequest;

  public constructor(public id: string) {
  }
}

/**
 * Get Slide Data By Slide Id Request
 */
export class GetSlideDataBySlideIdRequest {
  public static readonly type = ActionTypes.GetSlideDataBySlideIdRequest;

  public constructor(public slideId: number) {
  }
}

// </editor-fold>
